// ----------------------------------------------------------------------
// <copyright file="Izenda.ThresholdGridConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
/**
 * ThresholdGridConstants
 */

import localizer from 'share/localization/Izenda.Localizer';
import { flow, values, sumBy } from 'lodash/fp';

const DYNAMIC_TABLE_DEF = {
  type: {
    columnKey: 'Type',
    width: 100,
    get title() {
      return 'Type';
    },
    sortable: false,
    key: 'label'
  },
  field: {
    columnKey: 'Field',
    width: 140,
    get title() {
      return 'Field';
    },
    sortable: true,
    key: 'label'
  },
  label: {
    columnKey: 'Label',
    width: 120,
    get title() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_LABEL');
    },
    sortable: false,
    key: 'label'
  },
  value: {
    columnKey: 'Value',
    width: 140,
    get title() {
      return localizer.getText('COMMON_LABEL_VALUE');
    },
    sortable: false,
    key: 'value'
  },
  dashStyle: {
    columnKey: 'DashStyle',
    width: 100,
    get title() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_DASHSTYLE');
    },
    sortable: false,
    key: 'dashStyle'
  },
  color: {
    columnKey: 'Color',
    width: 50,
    get title() {
      return localizer.getText('COMMON_LABEL_COLOR');
    },
    sortable: false,
    key: 'color',
    align: 'center'
  },
  thickness: {
    columnKey: 'Thickness',
    width: 80,
    get title() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_THICKNESS');
    },
    sortable: false,
    key: 'thickness'
  },
  visible: {
    columnKey: 'Visible',
    width: 50,
    get title() {
      return localizer.getText('COMMON_LABEL_VISIBLE');
    },
    sortable: false,
    key: 'visible',
    align: 'center'
  },
  action: {
    columnKey: 'Action',
    width: 50,
    get title() {
      return localizer.getText('COMMON_LABEL_ACTION');
    },
    sortable: false,
    key: 'action',
    align: 'center'
  }
};
const TABLE_CONTAINER_STYLE = {
  width: flow(
    values,
    sumBy('width')
  )(DYNAMIC_TABLE_DEF)
};
export default {
  MESSAGE: {
    get M03() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_EXIST');
    },
    get M04() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_VALUE_EXIST');
    },
    get M05() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_REQUIRED_VALUE');
    },
    get M06() {
      return localizer.getText('THRESHOLD_GRID_CONSTANT_MESSAGE_THRESHOLD_REQUIRED_LABEL');
    }
  },
  TABLE_DEF: {
    label: {
      columnKey: 'Label',
      width: 130,
      get title() {
        return localizer.getText('THRESHOLD_GRID_CONSTANT_LABEL');
      },
      sortable: true,
      key: 'label'
    },
    value: {
      columnKey: 'Value',
      width: 130,
      get title() {
        return localizer.getText('COMMON_LABEL_VALUE');
      },
      sortable: true,
      key: 'value'
    },
    dashStyle: {
      columnKey: 'DashStyle',
      width: 100,
      get title() {
        return localizer.getText('THRESHOLD_GRID_CONSTANT_DASHSTYLE');
      },
      sortable: true,
      key: 'dashStyle'
    },
    color: {
      columnKey: 'Color',
      width: 60,
      get title() {
        return localizer.getText('COMMON_LABEL_COLOR');
      },
      sortable: true,
      key: 'color',
      align: 'center'
    },
    thickness: {
      columnKey: 'Thickness',
      width: 100,
      get title() {
        return localizer.getText('THRESHOLD_GRID_CONSTANT_THICKNESS');
      },
      sortable: true,
      key: 'thickness'
    },
    visible: {
      columnKey: 'Visible',
      width: 60,
      get title() {
        return localizer.getText('COMMON_LABEL_VISIBLE');
      },
      sortable: true,
      key: 'visible',
      align: 'center'
    },
    action: {
      columnKey: 'Action',
      width: 60,
      get title() {
        return localizer.getText('COMMON_LABEL_ACTION');
      },
      sortable: true,
      key: 'action',
      align: 'center'
    }
  },
  DEFAULT_VALUE: {
    COLOR: '#000',
    DASH_STYLE: 'solid',
    WIDTH: 1,
    FONT_STYLE: 'italic',
    FONT_WEIGHT: 'bold',
    TEXT_DECORATION: 'underline',
    ALIGNMENT: 'left',
    FONT_SIZE: 8
  },
  NUMBER_REGEX: /^-?\d*\.?\d*$/,
  SORT_DIRS: {
    name: 'DESC'
  },
  THRESHOLD_MAX_HEIGHT: 500,
  THRESLOD_TYPE: [{ value: 'static', label: 'Static' }, { value: 'dynamic', label: 'Dynamic' }],
  DYNAMIC_TABLE_DEF: DYNAMIC_TABLE_DEF,
  TABLE_CONTAINER_STYLE: TABLE_CONTAINER_STYLE
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ThresholdGridConstants.js